// extracted by mini-css-extract-plugin
module.exports = {"todo":"todo_todo__13YVo","todosInner":"todo_todosInner__39-wf","todoBody":"todo_todoBody__4fuNG"};